import { Form } from 'ant-design-vue'
import Vue from 'vue'
import Router from 'vue-router'
import NotFound from '../apps/index/NotFound.vue'
import { getFilteredMenuData } from '../service/common'
import { USER_GROUPS } from '../service/constant'
import { getUrlParams } from '../utils/urlUtils'
import store from './store/index'

Vue.use(Router)
export function getRouter(route) {
  let { routes } = route
  const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: routes.concat([
      {
        path: '/404',
        name: '404',
        component: NotFound
      },
      {
        path: '*',
        redirect: '/404'
      }
    ])
  })

  router.beforeResolve((to, from, next) => {
    const menus = getFilteredMenuData(store.state[USER_GROUPS])
    // console.log(to.path)
    // let noLoginPath = [
    //     '/prelogin','/ssoswitch'//
    // ]
    //
    // if(noLoginPath.includes(to.path)){
    //   return next()
    // }

    if (menus.length == 0) {
      return next()
    }

    // else {
      let ticket = getUrlParams().ticket
      let expected = menus[0].children[0].path

      // 登陆后，跳转到 '/'的路由自动跳转到可获取的第一个url
      if (menus.length > 0 && expected != '/' && to.path == '/') {
        console.log('redirect:' + expected)
        next({ path: expected, params: ticket ? { ticket } : {} })
      } else {
        console.log('normal')
        next()
      }
    // }
  })

  return router
}
